var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1235_12555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.967773 0H35.9518V35H0.967773V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1235_12555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9525 29.6785C35.9525 32.6158 33.5725 34.9968 30.6366 34.9968H6.28559C3.34967 34.9968 0.969727 32.6158 0.969727 29.6785V5.31634C0.969727 2.37908 3.34967 -0.00195312 6.28559 -0.00195312H30.6366C33.5725 -0.00195312 35.9525 2.37908 35.9525 5.31634V29.6785Z",
    fill: "#1A4789"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1486 20.2169L24.7139 15.8282H20.3703V13.0264C20.3703 11.756 20.7247 10.8901 22.5455 10.8901L24.8662 10.8888V6.96394C24.4656 6.91088 23.0878 6.79102 21.4822 6.79102C18.1332 6.79102 15.8419 8.8368 15.8419 12.5925V15.8282H12.0542V20.2169H15.8419V31.4766H20.3703V20.2169H24.1486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.a9f98912ad6abd8933dc7f7676d9e370.svg";
export { ForwardRef as ReactComponent };